var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaskBrush = function SvgMaskBrush(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.984 14.016c1.688 0 3 1.312 3 3A3.98 3.98 0 0 1 6 21c-1.5 0-3.094-.797-3.984-2.016.843 0 1.968-.656 1.968-1.968 0-1.688 1.36-3 3-3M20.72 4.64a1.02 1.02 0 0 1 0 1.406L11.766 15 9 12.234l8.953-8.953a1.02 1.02 0 0 1 1.406 0z"
  })));
};
export default SvgMaskBrush;